(function () {
  'use strict';

  function addRecipients () {
    return {
      'restrict': 'E',
      'templateUrl': 'components/recipients/add-recipients.html'
    };
  }

  angular.module('web2print.recipients')
    .directive('addRecipients', addRecipients);
})();
